(() => {
  const choices = {
    purchase_location: ['Sonic Dental Website', 'Amazon', 'Dentist / Dental Practice', 'Retailer', 'Gifted', 'Other'],
    appliance: ['Clear Aligner', 'Retainer', 'Night Guard', 'Sports Guard', 'Denture', 'None (other intended use)'],
    gift: ['Yes', 'No']
  };
  function initialise(root) {
    root.querySelectorAll('[data-klaviyo-warranty-form]').forEach(form => {
      if (form.dataset.initialised) return;
      form.dataset.initialised = 'true';
      form.noValidate = true;
      const button = form.querySelector('[type="submit"]');
      const status = form.querySelector('[data-form-status]');
      const text = key => form.querySelector(`[data-message="${key}"]`).textContent;
      const payment = form.querySelector('[data-warranty-payment]');
      const checkoutButton = form.querySelector('[data-warranty-checkout]');
      const paymentHint = form.querySelector('[data-warranty-payment-hint]');
      const submitLabel = button.textContent;
      let savedRegistration, checkoutBusy = false;
      let enabled = false, extendedEnabled = true, busy = false, completed = false;
      button.disabled = true;
      const announce = (key, focus = false) => {
        status.textContent = text(key);
        status.classList.toggle('warranty__message--error', ['error', 'invalid', 'unavailable', 'review', 'checkout-error', 'checkout-unavailable'].includes(key));
        if (focus) status.focus();
      };
      const extendedSelected = () => form.querySelector('[name="cover"]:checked')?.dataset.cover === 'extended';
      const updateCover = () => {
        const extended = extendedSelected();
        button.textContent = extended ? text('checkout-submit').replaceAll('[price]', () => form.dataset.extendedWarrantyPrice) : submitLabel;
        if (paymentHint) paymentHint.hidden = !extended;
      };
      form.addEventListener('change', updateCover);
      updateCover();
      async function checkout() {
        if (!savedRegistration || checkoutBusy) return;
        checkoutBusy = true; checkoutButton.disabled = true;
        form.setAttribute('aria-busy', 'true'); announce('checkout-opening', true);
        try {
          const root = window.Shopify.routes.root;
          const response = await fetch(root + 'cart.js', {cache:'no-store',signal:AbortSignal.timeout(15000)});
          if (!response.ok) throw Error('Cart unavailable');
          const cart = await response.json();
          // Recover an interrupted add without adding the same registration twice.
          const existing = cart.items.find(item => item.variant_id === savedRegistration.variant && item.properties?.['Registration reference'] === savedRegistration.reference);
          if (existing && existing.quantity !== 1) {
            const corrected = await fetch(root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},signal:AbortSignal.timeout(15000),
              body:JSON.stringify({id:existing.key,quantity:1})});
            if (!corrected.ok) throw Error('Warranty quantity could not be confirmed');
          } else if (!existing) {
            const added = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},signal:AbortSignal.timeout(15000),
              body:JSON.stringify({items:[{id:savedRegistration.variant,quantity:1,properties:savedRegistration.properties}]})});
            if (!added.ok) throw Error('Warranty could not be added');
          }
          window.location.assign(root + 'checkout');
        } catch {
          announce('checkout-error', true);
        } finally {
          checkoutBusy = false; checkoutButton.disabled = false; form.removeAttribute('aria-busy');
        }
      }
      checkoutButton?.addEventListener('click', checkout);
      let endpoint;
      try {
        endpoint = new URL(form.dataset.gorgiasEndpoint);
        if (endpoint.origin !== 'https://sonic-dental-forms.sonic-dental-cloudflare-forms.workers.dev' || endpoint.pathname !== '/' || endpoint.search || endpoint.hash || endpoint.username || endpoint.password) throw Error('Unexpected endpoint');
        endpoint.searchParams.set('kind', 'registration');
        if (form.dataset.submissionEnabled === 'true' && window.SonicWarranty) {
          const health = new URL(endpoint); health.searchParams.set('action', 'health');
          fetch(health, {credentials:'omit',cache:'no-store',signal:AbortSignal.timeout(10000)})
            .then(async response => {
              const readiness = await response.json();
              enabled = response.ok && readiness.configured === true;
              extendedEnabled = readiness.extendedConfigured !== false;
              button.disabled = !enabled || completed || busy;
              if (!enabled) announce('unavailable');
            }).catch(() => announce('unavailable'));
        } else announce('unavailable');
      } catch { announce('unavailable'); }
      form.addEventListener('input', event => {
        if (typeof event.target.setCustomValidity === 'function') {
          event.target.setCustomValidity('');
          event.target.removeAttribute('aria-invalid');
        }
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || completed) return;
        if (!enabled) { announce('unavailable', true); return; }
        const fields = new FormData(form);
        const value = name => String(fields.get(name) || '').trim();
        if (value('company_website')) { announce('error', true); return; }
        ['first_name', 'last_name', 'email'].forEach(name => {
          const input = form.elements.namedItem(name);
          input.value = name === 'email' ? value(name).toLowerCase() : value(name);
          input.setCustomValidity(input.value ? '' : text('invalid'));
        });
        const validOptions = Object.entries(choices).every(([name, allowed]) => allowed.includes(value(name)));
        if (!form.checkValidity() || !validOptions || !value('variant_id') || !value('sku') || value('confirm') !== 'Confirm') {
          announce('invalid');
          const invalid = form.querySelector(':invalid');
          if (invalid) { invalid.setAttribute('aria-invalid', 'true'); invalid.focus(); }
          else status.focus();
          return;
        }
        const cover = form.querySelector('[name="cover"]:checked');
        if (form.elements.namedItem('cover') && !['standard','extended'].includes(cover?.dataset.cover)) { announce('invalid', true); return; }
        const warrantyVariant = Number(form.dataset.extendedWarrantyVariant);
        if (cover?.dataset.cover === 'extended' && (!extendedEnabled || !Number.isSafeInteger(warrantyVariant) || warrantyVariant < 1 || form.dataset.extendedWarrantyAvailable !== 'true')) { announce('checkout-unavailable', true); return; }
        busy = true; button.disabled = true;
        form.setAttribute('aria-busy', 'true'); announce('sending');
        try {
          const receipt = await window.SonicWarranty.submit({ form, endpoint: endpoint.href, sitekey: form.dataset.turnstileSitekey,
            fields: { kind:'registration', first_name:value('first_name'), last_name:value('last_name'), email:value('email').toLowerCase(),
              product:value('product'), product_id:value('product_id'), variant_id:value('variant_id'), sku:value('sku'), colour:value('colour'),
              purchase_location:value('purchase_location'), order_number:value('order_number'), appliance:value('appliance'), gift:value('gift'),
              ...(cover ? {cover:cover.dataset.cover,cover_label:cover.value} : {}), locale:form.dataset.locale,
              confirm:value('confirm') === 'Confirm', marketing_consent:!!form.querySelector('[data-warranty-disclosure]'), website:value('company_website') },
            onProgress: () => announce('sending')
          });
          const extended = cover?.dataset.cover === 'extended';
          if (!['sending','delivered','review'].includes(receipt.state) || !receipt.reference) throw Error('No receipt');
          const needsPayment = extended && receipt.paymentStatus !== 'paid' && receipt.state !== 'review';
          completed = true;
          form.querySelector('[data-warranty-fields]').hidden = true;
          const reference = text('reference').replaceAll('[reference]', () => receipt.reference);
          if (needsPayment) {
            announce('checkout-opening');
          } else if (receipt.state === 'review') {
            announce('review'); status.textContent += ` ${reference}`;
          } else {
            announce('received');
            const heading = document.createElement('h2');
            heading.textContent = text(extended ? 'checkout-confirmed' : 'received');
            const detail = document.createElement('p');
            detail.textContent = reference;
            status.replaceChildren(heading, detail);
            status.classList.add('warranty__message--receipt');
          }
          status.focus();
          form.dispatchEvent(new CustomEvent(needsPayment ? 'warranty-registration:payment-pending' : 'warranty-registration:success', {bubbles:true,detail:{state:receipt.state,reference:receipt.reference}}));
          if (needsPayment) {
            savedRegistration = {variant:warrantyVariant,reference:receipt.reference,properties:{
              'Registration reference':receipt.reference,'Registered product':value('product'),'Registered SKU':value('sku'),
              'Registered variant':value('variant_id'),...(value('order_number') ? {'Original order':value('order_number')} : {})
            }};
            status.classList.remove('warranty__message--receipt');
            payment.querySelector('[data-warranty-payment-reference]').textContent = reference;
            payment.hidden = false;
            await checkout();
          }
        } catch (error) {
          // Keep details and the shared submission token so retry cannot duplicate a saved request.
          announce('error', true);
          if (error.warranty && error.customerMessage) status.textContent = error.customerMessage;
        } finally {
          busy = false; button.disabled = completed || !enabled; form.removeAttribute('aria-busy');
        }
      });
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
